module.exports = __webpack_public_path__ + "static/media/Lato-BoldItalic.1ba4767e.ttf";